import axios from 'axios'
import config from '../config'

export default {
    getTags(currentPage, perPage, tag, user_id) {
        return axios.get(config.publicPath + 'tags', {
            params: {_page: currentPage, itemsPerPage: perPage, name: tag, "user.id": user_id},
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    getTagSelect() {
        return axios.get(config.publicPath + 'tags', {
            params: {'groups[]': 'select', 'pagination': false},
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    createTag(formData) {
        return axios.post(config.publicPath + 'tags', formData, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getTag(id) {
        return axios.get(config.publicPath + 'tags/' + id);
    },
    updateTag(id, tag) {
        return axios.put(config.publicPath + 'tags/' + id, tag, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },
    deleteTag(id) {
        return axios.delete(config.publicPath + 'tags/' + id, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
}
